import {_SitemapCc} from "@localization/siteMap/breadcrumbs/_Sitemap.ContaContabil.ts";
import {_SitemapFornecedores} from "@localization/siteMap/breadcrumbs/_Sitemap.Fornecedores.ts";
import {_SitemapOrcamentos} from "@localization/siteMap/breadcrumbs/_Sitemap.Orcamentos.ts";
import {_SitemapFormaspagamento} from "@localization/siteMap/breadcrumbs/_Sitemap.Formaspagamento.ts";
import {_empresa_sitemap} from "@components/empresas/endpoints/__empresa_endpoints.ts";
import {PermissaoAplicacao} from "@models/seguranca/permissaoApp.ts";

export interface IMapDefinition {
    url: string;
    descricao: string;
    nome: string;
    permissao: PermissaoAplicacao[];
    fullUrl: string;
    children?: { [key: string]: IMapDefinition };
}

export type IMap = typeof _Sitemap[keyof typeof _Sitemap] & {
    children?: { [key: string]: IMap }
};

export const sitemapKeys = ['url',
    'descricao',
    'nome',
    'permissao',
    'fullUrl',]

/**
 * Mapa de navegação do site.
 * Lembrete: Não da pra usar os childrens como indexação direta, TU JA TENTOU OUTRA VEZ!!
 */
export const _Sitemap = {
    ['home']: {
        url: 'home',
        descricao: 'Pagina inicial',
        nome: 'Home',
        permissao: ['AbrirAplicacao'],
        fullUrl: '/',
    },
    ['produtos']: {
        url: 'produtos',
        descricao: 'Produtos',
        nome: 'Produtos',
        permissao: ['VisualizarProdutos'],
        fullUrl: '/produtos/menu',
        children:
            {
                ['menu']: {
                    url: 'menu',
                    descricao: 'Menu de produtos',
                    nome: 'Menu de produtos',
                    permissao: ['VisualizarProdutos'],
                    fullUrl: '/produtos/menu',
                },
                ['consulta']: {
                    url: 'consulta',
                    descricao: 'Consulta de produtos',
                    nome: 'Consulta de produtos',
                    permissao: ['VisualizarProdutos'],
                    fullUrl: '/produtos/consulta',
                },
                ['novo']: {
                    url: 'novo',
                    descricao: 'Novo produto',
                    nome: 'Novo produto',
                    permissao: ['VisualizarProdutos'],
                    fullUrl: '/produtos/novo',
                },
                ['detalhes']: {
                    url: 'detalhes',
                    descricao: 'Detalhes do produto',
                    nome: 'Detalhes do produto',
                    permissao: ['VisualizarProdutos'],
                    fullUrl: '/produtos/detalhes',
                },
            },
    },
    ['usuarios']: {
        url: 'usuarios',
        descricao: 'Usuarios',
        nome: 'Usuarios',
        permissao: ['VisualizarUsuarios'],
        fullUrl: '/usuarios/menu',
        children: {
            ['detalhes']: {
                url: 'detalhes',
                descricao: 'Detalhes do usuario',
                nome: 'Detalhes do usuario',
                permissao: ['VisualizarUsuarios'],
                fullUrl: '/usuarios/detalhes',
            },
        },
    },
    ['seguranca']: {
        url: 'seguranca',
        descricao: 'Segurança',
        nome: 'Segurança',
        permissao: ['VisualizarSeguranca'],
        fullUrl: '/seguranca',
        children:
            {
                ['usuarios']: {
                    url: 'usuarios',
                    descricao: 'Usuarios',
                    nome: 'Usuarios',
                    permissao: ['VisualizarUsuarios'],
                    fullUrl: '/seguranca/usuarios',
                },
            },
    },
    ['notificacoes']: {
        url: 'notificacoes',
        descricao: 'Notificações',
        nome: 'Notificações',
        permissao: [],
        fullUrl: '/notificacoes',
        children: {
            ['minhas']: {
                url: 'minhas',
                descricao: 'Minhas notificações',
                nome: 'Minhas notificações',
                permissao: [],
                fullUrl: '/notificacoes/minhas',
            },
        },
    },
    ['recurso']: {
        url: 'recurso',
        descricao: 'Recursos',
        nome: 'Recursos',
        permissao: ['VisualizarRecursoMembro'],
        fullUrl: '/recurso/menu',
        children:
            {
                ['menu']: {
                    url: 'menu',
                    descricao: 'Menu de recursos',
                    nome: 'Menu de recursos',
                    permissao: ['VisualizarRecursoMembro'],
                    fullUrl: '~',
                },
                ['detalhes']: {
                    url: 'detalhes',
                    descricao: 'Detalhes do recurso',
                    nome: 'Detalhes do recurso',
                    permissao: ['VisualizarRecursoMembro'],
                    fullUrl: '/recurso/detalhes',
                },
                ['gerenciamento']: {
                    url: 'gerenciamento',
                    descricao: 'Gerenciamento de recursos',
                    nome: 'Gerenciamento de recursos',
                    permissao: ['VisualizarRecursoMembro'],
                    fullUrl: '/recurso/gerenciamento',
                    children: {
                        ['detalhes']: { // Isso é um pouco incomum. O ideal seria aninhar diretamente no IMap.
                            url: 'detalhes',
                            descricao: 'Detalhes do recurso',
                            nome: 'Detalhes do recurso',
                            permissao: ['VisualizarRecursoMembro'],
                            fullUrl: '/recurso/detalhes',
                        },
                    },
                },
                ['transferencias']: {
                    url: 'transferencias',
                    descricao: 'Transferências de recursos',
                    nome: 'Transferências de recursos',
                    permissao: ['VisualizarRecursoMembro'],
                    fullUrl: '/recurso/transferencias',
                    children: {
                        ['lista']: {
                            url: 'lista',
                            descricao: 'Lista de transferências de recursos',
                            nome: 'Lista de transferências de recursos',
                            permissao: ['VisualizarRecursoMembro'],
                            fullUrl: '/recurso/transferencias/lista',
                        },
                        ['detalhes']: {
                            url: 'detalhes',
                            descricao: 'Detalhes da transferência de recurso',
                            nome: 'Detalhes da transferência de recurso',
                            permissao: ['VisualizarRecursoMembro'],
                            fullUrl: '/recurso/transferencias/detalhes',
                        },
                    },
                },
                ['membros']: {
                    url: 'membros',
                    descricao: 'Membros do recurso',
                    nome: 'Membros do recurso',
                    permissao: ['VisualizarRecursoMembro'],
                    fullUrl: '/recurso/membros/lista',
                },
                ['movimentacoes']: {
                    url: 'movimentacoes',
                    descricao: 'Movimentações de recursos',
                    nome: 'Movimentações de recursos',
                    permissao: ['VisualizarRecursoMembro'],
                    fullUrl: '/recurso/movimentacoes/lista',
                    children: {
                        ['lista']: {
                            url: 'lista',
                            descricao: 'Lista de movimentações de recursos',
                            nome: 'Lista de movimentações de recursos',
                            permissao: ['VisualizarRecursoMembro'],
                            fullUrl: '/recurso/movimentacoes/lista',
                        }
                    }
                }

            },
    },
    ['solicitacoes']: {
        url: 'solicitacao',
        descricao: 'Solicitações',
        nome: 'Solicitações',
        permissao: ['VisualizarSolicitacoesMembro'],
        fullUrl: '/solicitacao/menu',
        children:
            {
                ['menu']: {
                    url: 'menu',
                    descricao: 'Menu de solicitações',
                    nome: 'Menu de solicitações',
                    permissao: ['VisualizarSolicitacoesMembro'],
                    fullUrl: '/solicitacao/menu',
                },
                ['lista']: {
                    url: 'lista',
                    descricao: 'Lista de solicitações',
                    nome: 'Lista de solicitações',
                    permissao: ['VisualizarSolicitacoesMembro'],
                    fullUrl: '/solicitacao/lista',
                    children: {
                        ['detalhes']: {
                            url: 'detalhes',
                            descricao: 'Detalhes da solicitação',
                            nome: 'Detalhes da solicitação',
                            permissao: ['VisualizarSolicitacoesMembro'],
                            fullUrl: '/solicitacao/detalhes',
                        }
                    }
                },
                ['tipos']: {
                    url: 'tipos',
                    descricao: 'Tipos de solicitações',
                    nome: 'Tipos de solicitações',
                    permissao: ['VisualizarSolicitacoesMembro'],
                    fullUrl: '/solicitacao/tipos/lista',
                    children: {
                        ['lista']: {
                            url: 'lista',
                            descricao: 'Lista de tipos de solicitação',
                            nome: 'Lista de tipo de solicitação',
                            permissao: ['VisualizarSolicitacoesMembro'],
                            fullUrl: '/solicitacao/tipos/lista',
                        },
                        ['detalhes']: {
                            url: 'detalhes',
                            descricao: 'Detalhes do tipo de solicitação',
                            nome: 'Detalhes do tipo de solicitação',
                            permissao: ['VisualizarSolicitacoesMembro'],
                            fullUrl: '/solicitacao/tipos/detalhes',
                        },
                    },
                },
            },
    },
    ['contratos']: {
        url: 'contratos',
        descricao: 'Contratos',
        nome: 'Contratos',
        permissao: ['VisualizarContratos'],
        fullUrl: '/contratos/menu',
        children:
            {
                ['menu']: {
                    url: 'menu',
                    descricao: 'Menu de contratos',
                    nome: 'Menu de contratos',
                    permissao: ['VisualizarContratos'],
                    fullUrl: '/contratos/menu',
                },
                ['lista']: {
                    url: 'lista',
                    descricao: 'Lista de contratos',
                    nome: 'Lista de contratos',
                    permissao: ['VisualizarContratos'],
                    fullUrl: '/contratos/lista',
                },
                ['detalhes']: {
                    url: 'detalhes',
                    descricao: 'Detalhes do contrato',
                    nome: 'Detalhes do contrato',
                    permissao: ['VisualizarContratos'],
                    fullUrl: '/contratos/detalhes',
                },
            },
    },
    ['formasPagamento']: _SitemapFormaspagamento,
    ['contaContabil']: _SitemapCc,
    ['fornecedores']: _SitemapFornecedores,
    ['orcamento']: _SitemapOrcamentos,
    ['dashboard']: {
        url: 'dashboard',
        descricao: 'Dashboards',
        nome: 'Dashboards',
        permissao: ['AbrirAplicacao'],
        fullUrl: '/dashboard',
        children: {
            ['home']: {
                url: 'home',
                descricao: 'Dashboard inicial',
                nome: 'Dashboard inicial',
                permissao: ['AbrirAplicacao'],
                fullUrl: '/dashboard/home',
            },
            ['recurso']: {
                url: 'recurso',
                descricao: 'Dashboard de recursos',
                nome: 'Dashboard de recursos',
                permissao: ['AbrirAplicacao'],
                fullUrl: '/dashboard/recurso',
            },
            ['solicitacoes']: {
                url: 'solicitacoes',
                descricao: 'Dashboard de solicitações',
                nome: 'Dashboard de solicitações',
                permissao: ['AbrirAplicacao'],
                fullUrl: '/dashboard/solicitacoes',
            },
        },
    },
    ..._empresa_sitemap,
} as const;


export interface IMapWithPath {
    map: IMap;
    path: IMap[];
}

export const getByUrl = (fullUrl: string): IMapWithPath | undefined => {
    const keys = Object.keys(_Sitemap) as Array<keyof typeof _Sitemap>;
    const homeMap = _Sitemap['home'] as unknown as IMap;

    // Helper function to search recursively through the map structure
    const searchMap = (
        currentMap: IMap,
        currentPath: IMap[] = [],
    ): IMapWithPath | undefined => {
        // Check if current map matches the URL
        if (currentMap.fullUrl === fullUrl) {
            return {
                map: currentMap,
                path: currentPath.concat(currentMap),
            };
        }

        // console.log(Object.keys(currentMap).find(x => !sitemapKeys.some(x)));

        // If this map has children, search through them
        if (currentMap.children) {
            const childKeys = Object.keys(currentMap.children);
            for (const childKey of childKeys) {
                const childMap = currentMap.children[childKey];

                // Recursively search this child and its descendants
                const result = searchMap(
                    childMap as unknown as IMap,
                    currentPath.concat(currentMap),
                );

                // If found in this branch, return the result
                if (result) {
                    return result;
                }
            }
        }

        // Not found in this branch
        return undefined;
    };

    // First check if it's the home map
    if (homeMap.fullUrl === fullUrl) {
        return {
            map: homeMap,
            path: [homeMap],
        };
    }

    // Search through all top-level maps (except home)
    for (const key of keys) {
        if (key === 'home') continue; // Skip home as we already checked it

        const map = _Sitemap[key] as unknown as IMap;

        // Start search with an empty path
        const result = searchMap(map);

        if (result) {
            // Always add home as the first item in the path (except for home itself)
            return {
                map: result.map,
                path: [homeMap].concat(result.path),
            };
        }
    }

    return undefined;
};
